import React from 'react';
import { motion } from 'framer-motion';
import './PageHero.css';

const PageHero = ({ eyebrow, title, subtitle }) => (
  <section className="page-hero">
    <div className="container">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
      >
        {eyebrow && <span className="page-hero-eyebrow">{eyebrow}</span>}
        <h1 className="page-hero-title">{title}</h1>
        {subtitle && <p className="page-hero-subtitle">{subtitle}</p>}
      </motion.div>
    </div>
  </section>
);

export default PageHero;
